<template>
  <div>
    <transition name="fade">
      <div :key="'sms_check_dark'" class="pu_dark" v-show="$store.getters.modal.block"></div>
    </transition>
    <transition name="slide">
      <div class="search-block pu_bottom popup_click_hide" v-show="$store.getters.modal.block">
        <div class="pu_bottom_scroll" style="margin: auto">
          <div class="pu_bottom_inner scroll_y"
               style="display: flex; text-align: center; justify-content: space-between; flex-direction: column; border-radius: 10px; min-height: 300px;">
            <div style="padding: 10px 20px">
              <h3>{{ text('block_modal_header') }}</h3>
              <br>
              <!-- <span style="display: block" v-html="sanitize(text('block_modal_text', {}, {removeTags: true}))"></span> -->
              <span class="blockPopup__text" style="display: block" v-html="blockText"></span>
              
              <br>
            </div>
            <div style="padding: 0 20% 20px;">
              <a @click="close()" class="fbb_btn">
                {{ text('block_modal_button') }}
              </a>
            </div>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {SET_MODAL} from '@/store/mutations.type'
  import {mapGetters} from 'vuex'

  export default {
    name: 'BlockPopup',
    methods: {
      close() {
        document.body.classList.remove('overflow')
        this.$store.commit(SET_MODAL, {modal: 'block', status: false})
      }
    }, 
    computed: {
      // Сделано на случай разных источников текста в сторе. 
      blockText() {
        if (this.$store.getters.shopMode === 0) {
          return this.$store.getters.outlet.data.acceptance_18_plus_text;
        } else if (this.$store.getters.shopMode === 1) {
          return this.$store.getters.outlet.outlet.acceptance_18_plus_text;
        }
      }
    }
  }
</script>

<style scoped>
  .blockPopup__text {
    white-space: pre-line;
  }
</style>
